/*
* トーストの表示
*/
export default class Toast {
  constructor() {
    this.$toasts = document.querySelectorAll('[data-target="toastMessage"]');
  }

  attachEvent() {
    Array.prototype.forEach.call(this.$toasts, $toast => {
      if ($toast) {
        this.attachEventToElement($toast);
      }
    });
  }

  // 単一要素にイベントを設定
  attachEventToElement(element) {
    // 100ms後にアクティブクラス追加（フェードイン効果）
    setTimeout(() => {
      element.classList.add('is-active');
    }, 100);

    // クリックで閉じる
    element.addEventListener('click', () => {
      element.classList.remove('is-active');
    });

    // 5秒後に自動で閉じる
    setTimeout(() => {
      element.classList.remove('is-active');
    }, 5000);
  }

  // フラッシュメッセージ復元機能
  restoreFlashMessage() {
    try {
      // sessionStorageがサポートされているかチェック
      if (typeof Storage === 'undefined' || typeof sessionStorage === 'undefined') {
        return;
      }

      const message = sessionStorage.getItem('flash_notice');
      if (message) {
        this.showMessage(message);
        sessionStorage.removeItem('flash_notice');
      }
    } catch (error) {
      console.warn('Failed to restore flash notice:', error);
    }
  }

  // メッセージを即座に表示する機能
  showMessage(message, iconType = 'check_circle') {
    if (!message) return;

    const toast = document.createElement('div');
    toast.className = 'toast';
    toast.setAttribute('data-target', 'toastMessage');

    const toastInner = document.createElement('div');
    toastInner.className = 'toast__inner';

    const icon = document.createElement('i');
    icon.className = 'material-icons toast__icon';
    icon.textContent = iconType;
    toastInner.appendChild(icon);

    const messageNode = document.createElement('div');
    messageNode.className = 'toast__message';
    messageNode.textContent = message;
    toastInner.appendChild(messageNode);

    toast.appendChild(toastInner);
    document.body.appendChild(toast);

    // 直接、作成した要素にイベントを設定
    this.attachEventToElement(toast);
  }

  // フラッシュメッセージを安全にsessionStorageに保存する機能
  static setFlashNotice(message) {
    if (!message) {
      return;
    }

    try {
      // sessionStorageがサポートされているかチェック
      if (typeof Storage === 'undefined' || typeof sessionStorage === 'undefined') {
        console.warn('sessionStorage is not supported in this browser.');
        return;
      }

      // sessionStorageが無効化されていないかテスト
      sessionStorage.setItem('test', 'test');
      sessionStorage.removeItem('test');

      // フラッシュメッセージを保存
      sessionStorage.setItem('flash_notice', message);
    } catch (error) {
      console.warn('Failed to save flash notice to sessionStorage:', error);
    }
  }
}
